import { EntityProfileHeaderInfoItemBase } from '../../../../Entity'
import { APPLICANT_PROFILE_HEADER_INFO_ITEMS_LOADING_LENGTH } from '../RentalPortalApplicantProfileHeaderInfoItems.constants'

function ApplicantProfileHeaderInfoItemsSkeleton({ className }) {
  return Array.from({
    length: APPLICANT_PROFILE_HEADER_INFO_ITEMS_LOADING_LENGTH,
  }).map((_, index) => (
    <EntityProfileHeaderInfoItemBase
      isLoading
      className={className}
      key={index}
    />
  ))
}

export default ApplicantProfileHeaderInfoItemsSkeleton
